import React, { useState, useEffect } from "react";
import NavbarMob from "../components/NavbarMob";
import Navbar from "../components/Navbar";
import Navbar2 from "../components/Navbar2";
import Footer from "../components/Footer";
import { useMediaQuery } from "react-responsive";
import Navbar2Mob from "../components/Navbar2Mob";
import DatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";

function EnablePackage() {
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const navigate = useNavigate();

    // State for customers and search query
    const [customers, setCustomers] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [planExpiries, setPlanExpiries] = useState({}); // Object to hold expiry dates for each plan and customer
    const [loading, setLoading] = useState(true);

    // Fetch customer data from the API
    useEffect(() => {
        const fetchCustomers = async () => {
            try {
                const response = await fetch(`${apiBaseUrl}/getCandidatesplan`);
                if (!response.ok) {
                    throw new Error("Failed to fetch candidates");
                }

                const data = await response.json();

                // Ensure we have an array of candidates
                let candidates = data.candidates || data || [];

                // Sort by CandidateID descending (newest/highest ID first)
                const sortedCandidates = candidates.sort((a, b) => {
                    const idA = Number(a.CandidateID) || 0;
                    const idB = Number(b.CandidateID) || 0;
                    return idB - idA; // Higher ID comes first
                });

                // console.log("Sorted candidates by CandidateID (desc):", sortedCandidates);

                if (data.success || Array.isArray(candidates)) {
                    const customerNames = sortedCandidates.map((candidate) => ({
                        id: candidate.CandidateID,
                        name: candidate.Name,
                        Mobile: candidate.Mobile,
                        selectedPlan: candidate.SelectedPlan,
                        planDays: candidate.PlanDays || "nil",
                        expiryDate: candidate.ExpiryDate || "nil",
                        bigTown: candidate.bigTown,
                    }));

                    // Set customers state
                    setCustomers(customerNames);

                    // Initialize planExpiries state
                    const initialPlanExpiries = customerNames.reduce((acc, customer) => {
                        const expiry =
                            customer.expiryDate && customer.expiryDate !== "nil" ? new Date(customer.expiryDate) : null;

                        acc[customer.id] = {
                            300: customer.selectedPlan === "300" ? expiry : null,
                            500: customer.selectedPlan === "500" ? expiry : null,
                            600: customer.selectedPlan === "600" ? expiry : null,
                            800: customer.selectedPlan === "800" ? expiry : null,
                            0: customer.selectedPlan === "0" ? expiry : null,
                        };
                        return acc;
                    }, {});
                    setPlanExpiries(initialPlanExpiries);
                }
            } catch (error) {
                console.error("Error fetching customer data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchCustomers();
    }, [apiBaseUrl]);

    const cleanedSearchTerm = searchTerm
        .replace(/^\+91|\+91|\+/g, "") // Remove +91 at start, +91 anywhere, or lone +
        .replace(/\s/g, "") // Remove spaces
        .replace(/\D/g, "");

    // Filtered customers based on search term
    const filteredCustomers = customers.filter((customer) => {
        const cleanedMobile = customer.Mobile ? customer.Mobile.toString().replace(/\D/g, "") : "";
        return (
            customer.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            customer.id?.toString().includes(searchTerm) ||
            // customer.Mobile?.toString().includes(searchTerm) ||
            (cleanedSearchTerm && cleanedMobile.includes(cleanedSearchTerm)) ||
            customer.bigTown?.toLowerCase().includes(searchTerm.toLowerCase())
        );
    });

    // Function to handle plan expiry date changes
    const handlePlanExpiryChange = (customerId, plan, date) => {
        setPlanExpiries((prev) => ({
            ...prev,
            [customerId]: {
                ...prev[customerId],
                [plan]: date,
            },
        }));
    };

    // Function to set a plan with an expiry date
    const handleSetPlan = async (customerId, plan, expiryDate) => {
        if (!expiryDate) {
            alert(`Please select an expiration date for the ${plan} plan.`);
            return;
        }

        try {
            const response = await fetch(`${apiBaseUrl}/updateSelectedPlan`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    id: customerId,
                    selectedPlan: plan,
                    expiryDate: expiryDate,
                }),
            });

            const data = await response.json();
            if (data.success) {
                alert(
                    `Plan ${plan} until ${expiryDate.toLocaleDateString("en-GB")} set for ${customers.find((customer) => customer.id === customerId).name
                    }`
                );
                window.location.reload();
            } else {
                console.error("Error updating selected plan:", data.message);
            }
        } catch (error) {
            console.error("Error sending update request:", error);
        }
    };

    const handleDeletePlan = async (customerId) => {
        if (window.confirm("Are you sure you want to delete this plan?")) {
            try {
                const response = await fetch(`${apiBaseUrl}/deletePlan`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        id: customerId,
                    }),
                });

                const data = await response.json();
                if (data.success) {
                    alert("Plan deleted successfully");
                    window.location.reload();
                } else {
                    console.error("Error deleting plan:", data.message);
                    alert("Failed to delete plan");
                }
            } catch (error) {
                console.error("Error sending delete request:", error);
                alert("Error deleting plan");
            }
        }
    };

    const planpage = () => {
        navigate("/plan");
    };

    const backuppage = () => {
        navigate("/backup");
    };

    return (
        <div className="min-h-screen flex flex-col">
            {isMobile ? <NavbarMob /> : <Navbar />}
            <div className="md:flex hidden">
                <Navbar2 />
            </div>
            <div className="md:hidden flex flex-col">
                <Navbar2Mob />
            </div>

            <div className="lg:px-12 px-3 py-12 flex bg-[#eeebeb] w-full flex-col min-h-screen">
                <div className="w-full flex justify-between items-center pb-6">
                    <span
                        className="underline cursor-pointer lg:text-base text-xs font-display font-[600]"
                        onClick={planpage}
                    >
                        Create Package
                    </span>
                    <span
                        className="underline cursor-pointer lg:text-base text-xs font-display font-[600]"
                        onClick={backuppage}
                    >
                        Take Backup
                    </span>
                </div>
                <input
                    type="text"
                    placeholder="Search by Place, Candidate Id, Name or Number"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="mb-4 p-2 border border-gray-300 rounded"
                />
                <div className="overflow-auto max-h-[60vh]">
                    {loading ? (
                        <div className="flex justify-center items-center h-64">
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
                        </div>
                    ) : (
                        <table className="table-auto w-full border-collapse bg-gray-50">
                            <thead className="bg-blue-600 text-white sticky top-0 z-10 shadow-md">
                                <tr className="bg-blue-600 text-white">
                                    <th className="lg:p-4 p-1 border lg:text-base text-xs">ID</th>
                                    <th className="lg:p-4 p-1 border lg:text-base text-xs font-display">Customer Name</th>
                                    <th className="lg:p-4 p-1 border lg:text-base text-xs font-display">Mobile Number</th>
                                    <th className="lg:p-4 p-1 border lg:text-base text-xs font-display">Nearest Town</th>
                                    <th className="lg:p-4 p-1 border lg:text-base text-xs font-display">300 Plan</th>
                                    <th className="lg:p-4 p-1 border lg:text-base text-xs font-display">500 Plan</th>
                                    <th className="lg:p-4 p-1 border lg:text-base text-xs font-display">500 Plan (TVM/EKM)</th>
                                    <th className="lg:p-4 p-1 border lg:text-base text-xs font-display">800 Plan (TVM/EKM)</th>
                                    <th className="lg:p-4 p-1 border lg:text-base text-xs font-display">Old Plan</th>
                                    <th className="lg:p-4 p-1 border lg:text-base text-xs font-display">Expiry date</th>
                                    <th className="lg:p-4 p-1 border lg:text-base text-xs font-display">Custom Plan</th>
                                    <th className="lg:p-4 p-1 border lg:text-base text-xs font-display">Delete Plan</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredCustomers.map((customer) => (
                                    <tr key={customer.id} className="text-center">
                                        <td className="lg:p-4 p-1 border font-display lg:text-base text-xs">{customer.id}</td>
                                        <td className="lg:p-4 p-1 border font-display lg:text-base text-xs">{customer.name}</td>
                                        <td className="lg:p-4 p-1 border font-display lg:text-base text-xs">
                                            {customer.Mobile}
                                        </td>
                                        <td
                                            className="p-1 border font-display text-xs lg:text-base w-32 truncate max-w-[8rem]"
                                            title={customer.bigTown}
                                        >
                                            {customer.bigTown}
                                        </td>

                                        <td className="lg:p-4 p-1 border">
                                            <DatePicker
                                                selected={planExpiries[customer.id]?.["300"]}
                                                onChange={(date) => handlePlanExpiryChange(customer.id, "300", date)}
                                                minDate={new Date()}
                                                dateFormat="yyyy-MM-dd"
                                                className="p-1 border w-36"
                                                placeholderText="Select expiry date"
                                            />
                                            <button
                                                onClick={() =>
                                                    handleSetPlan(customer.id, "300", planExpiries[customer.id]?.["300"])
                                                }
                                                className="m-2 p-2 bg-blue-500 text-white rounded"
                                            >
                                                Set Plan
                                            </button>
                                        </td>

                                        <td className="lg:p-4 p-1 border">
                                            <DatePicker
                                                selected={planExpiries[customer.id]?.["500"]}
                                                onChange={(date) => handlePlanExpiryChange(customer.id, "500", date)}
                                                minDate={new Date()}
                                                dateFormat="yyyy-MM-dd"
                                                className="p-1 border w-36"
                                                placeholderText="Select expiry date"
                                            />
                                            <button
                                                onClick={() =>
                                                    handleSetPlan(customer.id, "500", planExpiries[customer.id]?.["500"])
                                                }
                                                className="m-2 p-2 bg-blue-500 text-white rounded"
                                            >
                                                Set Plan
                                            </button>
                                        </td>
                                        <td className="lg:p-4 p-1 border">
                                            <input
                                                type="checkbox"
                                                name={`600plan-${customer.id}`}
                                                checked={customer.selectedPlan === "600"}
                                                onChange={() =>
                                                    handleSetPlan(customer.id, "600", planExpiries[customer.id]?.["600"])
                                                }
                                            />
                                        </td>
                                        <td className="lg:p-4 p-1 border">
                                            <input
                                                type="checkbox"
                                                name={`800plan-${customer.id}`}
                                                checked={customer.selectedPlan === "800"}
                                                onChange={() =>
                                                    handleSetPlan(customer.id, "800", planExpiries[customer.id]?.["800"])
                                                }
                                            />
                                        </td>
                                        <td className="lg:p-4 p-1 border">
                                            <span className="text-black">{customer.planDays}</span>
                                        </td>
                                        <td className="lg:p-4 p-1 border">
                                            <span className="text-black">
                                                {customer.expiryDate
                                                    ? new Date(customer.expiryDate).toLocaleDateString("en-GB")
                                                    : "N/A"}
                                            </span>
                                        </td>
                                        <td className="lg:p-4 p-1 border">
                                            <DatePicker
                                                selected={planExpiries[customer.id]?.["0"]}
                                                onChange={(date) => handlePlanExpiryChange(customer.id, "0", date)}
                                                minDate={new Date()}
                                                dateFormat="yyyy-MM-dd"
                                                className="p-1 border w-36"
                                                placeholderText="Select expiry date"
                                            />
                                            <button
                                                onClick={() =>
                                                    handleSetPlan(customer.id, "0", planExpiries[customer.id]?.["0"])
                                                }
                                                className="m-2 p-2 bg-blue-500 text-white rounded"
                                            >
                                                Set Plan
                                            </button>
                                        </td>
                                        <td className="lg:p-4 p-1 border">
                                            <button
                                                onClick={() => handleDeletePlan(customer.id)}
                                                className="p-2 bg-red-500 text-white rounded hover:bg-red-600"
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>

            <Footer />
        </div>
    );
}

export default EnablePackage;
